import { useSearchParams } from "react-router-dom";
import AppShell, { Protected } from "@/components/AppShell";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { useAuth } from "@/lib/auth";
import AccountPanel from "@/pages/panels/AccountPanel";
import CabinetPanel from "@/pages/panels/CabinetPanel";
import EstablishmentPanel from "@/pages/panels/EstablishmentPanel";
import AuditPanel from "@/pages/panels/AuditPanel";
import BillingPanel from "@/pages/panels/BillingPanel";
import NotificationsPanel from "@/pages/panels/NotificationsPanel";
import StatsPanel from "@/pages/panels/StatsPanel";
import LegalPanel from "@/pages/panels/LegalPanel";

export default function Settings() {
  const { user } = useAuth();
  const isAdmin = (user?.role || "admin") === "admin" || user?.role === "org_admin";
  const VALID = isAdmin
    ? ["account", "stats", "notifications", "billing", "cabinet", "establishment", "audit", "legal"]
    : ["account", "legal"];
  const [searchParams, setSearchParams] = useSearchParams();
  const initial = searchParams.get("tab");
  const tab = VALID.includes(initial) ? initial : "account";

  const onTabChange = (v) => {
    const next = new URLSearchParams(searchParams);
    if (v === "account") next.delete("tab"); else next.set("tab", v);
    setSearchParams(next, { replace: true });
  };

  return (
    <Protected>
      <AppShell title="Paramètres">
        <Tabs value={tab} onValueChange={onTabChange}>
          <TabsList className="mb-6 bg-white border border-[#E1E9F0] p-1 rounded-[14px] h-auto flex-wrap gap-1">
            <TabsTrigger value="account" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-account">Mon compte</TabsTrigger>
            {isAdmin && <TabsTrigger value="notifications" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-notifications">Notifications</TabsTrigger>}
            {isAdmin && <TabsTrigger value="billing" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-billing">Abonnement</TabsTrigger>}
            {isAdmin && <TabsTrigger value="cabinet" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-cabinet">Cabinet</TabsTrigger>}
            {isAdmin && <TabsTrigger value="establishment" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-establishment">Établissement</TabsTrigger>}
            {isAdmin && <TabsTrigger value="stats" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-stats">Statistiques</TabsTrigger>}
            {isAdmin && <TabsTrigger value="audit" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-audit">Journal d'audit</TabsTrigger>}
            <TabsTrigger value="legal" className="rounded-[10px] data-[state=active]:bg-[#5F758F] data-[state=active]:text-white text-[#5F758F] font-medium px-4 py-2" data-testid="settings-tab-legal">Légal</TabsTrigger>
          </TabsList>
          <TabsContent value="account"><AccountPanel /></TabsContent>
          {isAdmin && <TabsContent value="stats"><StatsPanel /></TabsContent>}
          {isAdmin && <TabsContent value="notifications"><NotificationsPanel /></TabsContent>}
          {isAdmin && <TabsContent value="billing"><BillingPanel /></TabsContent>}
          {isAdmin && <TabsContent value="cabinet"><CabinetPanel /></TabsContent>}
          {isAdmin && <TabsContent value="establishment"><EstablishmentPanel /></TabsContent>}
          {isAdmin && <TabsContent value="audit"><AuditPanel /></TabsContent>}
          <TabsContent value="legal"><LegalPanel /></TabsContent>
        </Tabs>
      </AppShell>
    </Protected>
  );
}
